export default __webpack_public_path__ + "static/media/3.b5c27437.png";